import { mixpanel } from '@fiverr-private/obs';
import { getStoredData } from '../utils';
import { MIXPANEL_EVENT_PROPERTIES } from '../../../../../shared/mixpanel';
import { ElementsList, ReportClickPayload, VariationType } from './types';
import { MIXPANEL_EVENT_NAMES } from './constants';

const getPayload = (event: ReportClickPayload) => {
    const {
        PROJECT_NAME,
        NEW_BRAND_NAME,
        SERVICE_NAME,
        ACTION,
        IS_FREE,
        VARIATION_TYPE,
    } = MIXPANEL_EVENT_PROPERTIES;

    switch (event.element) {
        case ElementsList.QUIZ_PROJECT:
            return {
                [PROJECT_NAME]: event.payload?.projectName,
                [ACTION]: event.payload?.action,
            };
        case ElementsList.QUIZ_PROJECT_SERVICE:
            return {
                [SERVICE_NAME]: event.payload?.serviceName,
            };
        case ElementsList.NEW_LOGO:
            return {
                [NEW_BRAND_NAME]: event.payload?.newBrandName,
            };
        case ElementsList.CREATE_NEW:
            return {
                [IS_FREE]: event.payload?.isFree,
            };
        case ElementsList.SPECIAL_VARIATION:
            return {
                [VARIATION_TYPE]: event.payload?.variationType,
            };
        default:
            return null;
    }
};

const reportClick = (event: ReportClickPayload): void => {
    const customPayload = {
        ...getStoredData(),
        ...getPayload(event),
    };

    mixpanel.track(MIXPANEL_EVENT_NAMES[event.element], customPayload);
};

reportClick.ELEMENTS_LIST = ElementsList;
reportClick.VARIATION_TYPE = VariationType;

export { reportClick };
